import React, { useEffect, useMemo, useRef, useState, useImperativeHandle } from 'react';
import { Tooltip } from 'antd';
import { Checkbox } from '@web-common/components/UI/Checkbox';
import message from '@web-common/components/UI/Message/SiriusMessage';
import moment from 'moment';
import { apiHolder as api, apis, util, isElectron, ProductAuthorityFeature, locationHelper, isEdm, getIn18Text, } from 'api';
import { navigateWithSearchQuery } from '@web-common/utils/utils';
import { navigate } from 'gatsby';
import style from './index.module.scss';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { comIsShowByAuth } from '@web-common/utils/utils';
import { AppActions, MailActions } from '@web-common/state/reducer';
import { actions as attachmentActions } from '@web-common/state/reducer/attachmentReducer';
import { dealTaskMail, dealPraiseMail, resetMailWithDraft, getWaittingSaveMails, parsePlainEmailFromErrorRcptString } from './utils';
import SaveDraft from './SaveDraft';
import ScheduledSent from './ScheduledSent';
import EncryptMail from './EncryptMail';
import ReadRemindComp from './ReadRemindComp';
import SenderSelectComp from './SenderSelectComp';
import SaveAsTemplateComp from './SaveAsTemplateComp';
import calendarSubmit from './calendarSubmit';
import SendValidateComp from './SendValidateComp';
import SendErrorContect from '@web-mail-write/components/SendMail/SendErrorContect';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { joinWebmailActivity } from '@web-common/components/util/webmail-util';
import { edmOperateVarBeforeSend, edmOperateVarSubject, getvarList } from '@web-mail-write/components/SendMail/utils';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { attachmentDownloadAction } from '@web-common/state/action';
import CloseButton from './CloseButton';
import useReupload from './useReupload';
import Dialog from '@web-common/components/UI/Dialog/dialog';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import { ReactComponent as IconWarn } from '@/images/icons/icon-warn.svg';
import MailSize from './MailSize';
import { mailContentHasVar, textHaveVar } from '@web-mail-write/components/SendMail/utils';
import { useZoneParamsByContact } from '@web-mail-write/components/WriteContact/writeSide';
import Auth from './Auth';
const systemApi = api.api.getSystemApi();
const inElectron = isElectron();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const mailDraftApi = api.api.requireLogicalApi(apis.mailDraftApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const dataStoreApi = api.api.getDataStoreApi();
const eventApi = api.api.getEventApi();
const diskApi = api.api.requireLogicalApi(apis.netStorageImpl);
const loggerApi = api.api.requireLogicalApi(apis.loggerApiImpl);
const SendMail = React.forwardRef((props, ref) => {
    const [visibleErrorContect, setVisibleErrorContect] = useState(false);
    const [errorMsg, setErrorMsg] = useState({});
    const sendRef = useRef(null);
    const [showSaveTime, setShowSaveTime] = useState(true);
    const { sendLoading, setVisibleConf, execAutoSaveDraft = false, forceSave, isContentChanged, tooltipVisible, setTooltipVisible, saveTime, setSaveTime, updateSaveTime, innerCloseTab, scheduledSent, setScheduledSent, editorInstance, onSendSuccess, } = props;
    const { currentMail, mails } = useAppSelector(state => state.mailReducer);
    const { tabList } = useAppSelector(state => state.mailTabReducer);
    const senderReceivers = useAppSelector(state => state.mailReducer.currentMail.senderReceivers);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const { doChangeMailContent, doSetPuretext } = MailActions;
    const optSenderMainEmail = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSenderMainEmail; });
    const scheduleDate = useAppSelector(state => state.mailReducer.currentMail.scheduleDate);
    const setEncrypt = useAppSelector(state => state.mailReducer.currentMail.setEncrypt);
    const appActions = useActions(AppActions);
    const [sender, setSender] = useState(null);
    const receiverMemo = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver, [visibleErrorContect]);
    const priority = useMemo(() => { var _a; return (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.priority; }, [currentMail]);
    const subAccountExpired = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.subAccountExpired, [currentMail]);
    const requestReadReceipt = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.requestReadReceipt, [currentMail]);
    const senderEmail = useMemo(() => (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '', [currentMailId, currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr]);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const dispatch = useAppDispatch();
    const conferenceShow = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.conferenceShow; });
    const praiseMailShow = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.praiseMailShow; });
    const taskMailShow = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.taskMailShow; });
    const puretext = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.puretext; });
    const currentMailTitle = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.title; });
    const sendfooterRef = useRef(null);
    const currentMailIdRef = useRef(currentMailId);
    currentMailIdRef.current = currentMailId;
    const currentTabIdRef = useRef(currentTabId);
    currentTabIdRef.current = currentTabId;
    const currentMailRef = useRef(currentMail);
    currentMailRef.current = currentMail;
    const mailsRef = useRef(mails);
    mailsRef.current = mails;
    const { reUploadHandler, clearMidFile, reUploadHandlerWeb } = useReupload();
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const [puretextVisible, setPuretextVisible] = useState(false);
    const [isSub, setIsSub] = useState(false);
    const paidGuideModal = useNiceModal('paidGuide');
    const { systemVariableList, customVariableList } = useAppSelector(state => state.configReducer);
    const [variableList, setVariableList] = useState();
    const [authData, setAuthData] = useState({ authPath: '', show: false, curSendId: '' });
    useEffect(() => {
        const data = getvarList(systemVariableList, customVariableList);
        data && setVariableList(data);
    }, [systemVariableList, customVariableList]);
    const encryptMailCkShow = useMemo(() => {
        const { writeType, isEncryptedMail, isDyncGroupSend } = currentMail;
        if (isSub || isDyncGroupSend)
            return false;
        if (isEncryptedMail && ((writeType === null || writeType === void 0 ? void 0 : writeType.includes('reply')) || (writeType === null || writeType === void 0 ? void 0 : writeType.includes('forward')))) {
            return false;
        }
        return true;
    }, [currentMail, isSub]);
    const getTargetEditStatus = (cid) => {
        try {
            if (!cid)
                return currentMailRef.current.mailEditStatus;
            const target = (mailsRef.current || []).find(mail => mail.cid === cid);
            if (target)
                return target.mailEditStatus;
            return '';
        }
        catch (error) {
            return '';
        }
    };
    useEffect(() => {
        if (isSub) {
            dispatch(mailActions.doChangeMailSetEncrypt(false));
            dispatch(mailActions.doChangeMailEncpwd(''));
            dispatch(mailActions.doChangeMailSavePassword(false));
        }
    }, [isSub]);
    const encryptMailDisabled = useMemo(() => {
        const { status } = currentMail;
        const { praiseMailShow, taskMailShow, conferenceShow } = status || {};
        if (praiseMailShow || taskMailShow || conferenceShow || scheduledSent) {
            return true;
        }
        return false;
    }, [currentMail, scheduledSent]);
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const sucDealReducer = useCreateCallbackForEvent(async (curCid, isSendCurrentMail) => {
        const { pathname } = window.location;
        if (isSendCurrentMail) {
            curCid && dispatch(mailActions.doCloseMail(curCid));
        }
        else {
            curCid && dispatch(mailActions.doClearMails([curCid]));
        }
        if (inElectron) {
            if (pathname.includes('/writeMail')) {
                setTimeout(() => {
                    const isLowMemoryMode = systemApi.getIsLowMemoryModeSync();
                    const isSendAttachmentPage = mailApi.getIsSendAttachmentWritePage();
                    if (isLowMemoryMode || isSendAttachmentPage) {
                        window.electronLib.windowManage.getCurWindow().then((res) => {
                            const winId = res.id;
                            setTimeout(() => {
                                window.electronLib.windowManage.hide(winId);
                            }, 0);
                        });
                        setTimeout(() => {
                            systemApi.closeWindow();
                        }, 1200);
                    }
                    else {
                        systemApi.closeWindow();
                    }
                }, 300);
            }
            else {
                if (isSendCurrentMail) {
                    setTimeout(() => {
                        dispatch(mailTabActions.doCloseTab(String(curCid)));
                    }, 1000);
                }
                else {
                    dispatch(mailTabActions.doClearTabs([String(curCid)]));
                }
            }
            return;
        }
        if (pathname.includes('/writeMail')) {
            navigate('/#mailbox');
            dispatch(mailTabActions.doChangeCurrentTab('-1'));
            return;
        }
        if (isSendCurrentMail) {
            setTimeout(() => {
                dispatch(mailTabActions.doCloseTab(String(curCid)));
            }, 800);
        }
        else {
            dispatch(mailTabActions.doClearTabs([String(curCid)]));
        }
    });
    const errorContectResend = errorMsg => {
        var _a;
        const errEmails = (errorMsg.msgItem || []).map((item) => parsePlainEmailFromErrorRcptString(item === null || item === void 0 ? void 0 : item.email));
        const errReceivers = new Set(errEmails.filter((e) => e.length > 0));
        const filterReveivers = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) === null || _a === void 0 ? void 0 : _a.filter(item => { var _a, _b; return !errReceivers.has(parsePlainEmailFromErrorRcptString(((_b = (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName) || '')); });
        dispatch(mailActions.doReplaceReceiver(filterReveivers));
        if (filterReveivers.length === 0) {
            return;
        }
        saveSend({ receiver: filterReveivers });
    };
    const { zoneParams } = useZoneParamsByContact();
    const scheduledSentChange = () => {
        var _a, _b, _c;
        if (scheduledSent) {
            dispatch(mailActions.doChangeMailSchedule(undefined));
            dispatch(mailActions.doChangeMailScheduleTimeZone(undefined));
        }
        if (!scheduledSent) {
            if (!scheduleDate) {
                const diff = 30 -
                    (moment()
                        .utcOffset(((_a = systemApi.getSystemTimeZone()) === null || _a === void 0 ? void 0 : _a.key) || 8)
                        .minute() %
                        5);
                dispatch(mailActions.doChangeMailSchedule(moment()
                    .add(diff, 'm')
                    .utcOffset(((_b = systemApi.getSystemTimeZone()) === null || _b === void 0 ? void 0 : _b.key) || 8)
                    .format('YYYY-MM-DD HH:mm:ss')));
                if ((process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) && zoneParams.zoneOffset !== null) {
                    dispatch(mailActions.doChangeMailScheduleTimeZone(zoneParams.zoneOffset));
                }
                else {
                    dispatch(mailActions.doChangeMailScheduleTimeZone((_c = systemApi.getSystemTimeZone()) === null || _c === void 0 ? void 0 : _c.key));
                }
            }
        }
        setScheduledSent && setScheduledSent(data => !data);
    };
    const scheduledSentChangeDisabled = () => {
        if (taskMailShow) {
            message.warn({
                content: getIn18Text('RENWUYOUJIANZAN'),
            });
        }
        else if (praiseMailShow) {
            message.warn({
                content: getIn18Text('BIAOYANGYOUJIANZAN'),
            });
        }
    };
    const encryptMailChange = () => {
        if (setEncrypt) {
            dispatch(mailActions.doChangeMailSetEncrypt(false));
            dispatch(mailActions.doChangeMailEncpwd(''));
            dispatch(mailActions.doChangeMailSavePassword(false));
        }
        else {
            dispatch(mailActions.doChangeMailSetEncrypt(true));
        }
    };
    const paidGuideShow = (errType) => {
        if (errType === '7') {
            paidGuideModal.show({ errType: errType, origin: '写信页' });
        }
        else if (errType === '8') {
            paidGuideModal.show({ errType: errType, origin: '写信页' });
        }
    };
    const emergencyChange = () => {
        const targetPriority = priority === 1 ? 3 : 1;
        dispatch(mailActions.doChangeMailEmergency(targetPriority));
    };
    const requestReadReceiptChange = () => {
        dataStoreApi.put('requestReadReceiptStore', String(+!requestReadReceipt));
        dispatch(mailActions.doChangeRequestReadReceipt(!requestReadReceipt));
    };
    useEffect(() => {
        dataStoreApi.get('requestReadReceiptStore').then(({ data }) => {
            const status = data || '0';
            dispatch(mailActions.doChangeRequestReadReceipt(!!+status));
        });
    }, [currentMailId]);
    useImperativeHandle(ref, () => {
        return {
            toSaveSend() {
                saveSend();
            },
        };
    });
    const reUploadAtts = useCreateCallbackForEvent(async (resendAccount) => {
        const oldCid = currentMailId;
        if (inElectron) {
            try {
                dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: 'reUploading' }));
                const reUploadRes = await reUploadHandler(resendAccount);
                dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
                console.log('reUploadResreUploadResreUploadRes', reUploadRes);
                if (reUploadRes && reUploadRes.every(i => i.status === 'fulfilled')) {
                    message.success({ content: getIn18Text('SHANGCHUANWANCHENG'), className: style.succMsg });
                    dispatch(mailActions.doModifyInitSenderStr(optSenderMainEmail || ''));
                }
                else {
                    message.error(getIn18Text('BUFENFUJHTPSCSBQZS'));
                }
            }
            catch (err) {
                console.log('附件重传失败', err);
                dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            }
        }
        else {
            try {
                if (reUploadHandlerWeb) {
                    let includePaste = false;
                    const currentAttachment = attachments.filter(i => i.mailId === oldCid && (i === null || i === void 0 ? void 0 : i.attOpt) === 'paste');
                    if (currentAttachment === null || currentAttachment === void 0 ? void 0 : currentAttachment.length)
                        includePaste = true;
                    dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: 'reUploading' }));
                    const reUploadWebRes = await reUploadHandlerWeb(resendAccount, false, forceSave);
                    dispatch(mailActions.doModifyInitSenderStr(optSenderMainEmail || ''));
                    dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
                    if (includePaste) {
                        message.success({
                            content: React.createElement("span", { className: style.longMsg }, getIn18Text('KUAZHANGHAONTFJZQHZH22')),
                            className: style.succMsg1,
                            duration: 3,
                        });
                    }
                    else {
                        message.success({ content: getIn18Text('SHANGCHUANWANCHENG'), className: style.succMsg });
                    }
                }
            }
            catch (error) {
                message.error(getIn18Text('BUFENFUJHTPSCSBQZS'));
                dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            }
        }
    });
    const renewalCloudAtt = async (attachments) => {
        if (productVersionId !== 'ultimate')
            return;
        const renewIds = [];
        attachments.forEach((att) => {
            const { expired, cloudAttachment, id, docId } = att;
            if (expired) {
                if (cloudAttachment && id) {
                    typeof id === 'string' && renewIds.push(id);
                }
                if (!cloudAttachment && docId) {
                    typeof docId === 'string' && renewIds.push(docId);
                }
            }
        });
        if (renewIds.length) {
            try {
                const res = await diskApi.renewAttachments({ identities: renewIds });
                if (res !== true) {
                    console.log('发信云附件续期失败');
                }
            }
            catch (err) {
                console.log('发信云附件续期失败', err);
            }
        }
    };
    const delLocalDraft = async (curCid) => {
        try {
            const delRes = await mailDraftApi.deleteDraftMailByCid(curCid);
            const { success, message } = delRes;
            if (success) {
                eventApi.sendSysEvent({
                    eventName: 'refreshLocalDraft',
                    eventData: {},
                });
                return;
            }
            console.log('发信删除草稿邮件失败', message || '');
        }
        catch (error) {
            console.log('发信删除草稿邮件失败', error);
        }
    };
    const mailReset = useCreateCallbackForEvent(async () => {
        var _a;
        const { draftId, _account, cid } = currentMail;
        let latestedDraftId = draftId;
        try {
            const res = await mailApi.doSaveTemp({ content: currentMail, saveDraft: true, auto: true, callPurpose: 'resetSaveDraft' });
            console.log('forceSave res', res, latestedDraftId);
            if (res.draftId) {
                latestedDraftId = res.draftId;
            }
        }
        catch (error) {
            console.log('重置前保存草稿失败', error);
        }
        if (!latestedDraftId) {
            SiriusMessage.error({ content: getIn18Text('HUIFUSHIBAI') });
            return;
        }
        const curAccountId = _account ? accountApi.getEmailIdByEmail(_account) : '';
        console.log('curAccountId', curAccountId);
        if (!curAccountId || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) === curAccountId) {
            cid && resetMailWithDraft(cid);
            return;
        }
        const oldCid = cid;
        const draftParams = {
            id: latestedDraftId,
            mailType: 'draft',
            writeType: 'editDraft',
            withoutPlaceholder: true,
            _account: _account,
        };
        const res = await mailApi.initModel(draftParams);
        if (res) {
            const { cid: newCid } = res;
            res.recoverCid = oldCid;
            dispatch(mailActions.doReplaceMail(res));
            dispatch(mailTabActions.doReplaceTabById({ id: String(newCid), recoverCid: String(oldCid) }));
            oldCid && dispatch(attachmentActions.doDelAttachment({ cid: [oldCid] }));
            const filterAttachment = (res.entry.attachment || []).filter(item => !item.inlined);
            filterAttachment.forEach(attachment => {
                const temp = Object.assign(Object.assign({}, attachment), { mailId: res.cid, downloadContentId: res.entry.id, downloadId: attachment.fileUrl + res.entry.id, type: 'download', cloudAttachment: attachment.type === 'netfolder' });
                dispatch(attachmentDownloadAction(temp, {
                    forward: true,
                    entryId: res.entry.id,
                    cid: res.cid || '0',
                }));
            });
        }
    });
    const mailStatusError = () => {
        const modal = SiriusModal.error({
            title: getIn18Text('YOUJIANFUJZTYC'),
            content: getIn18Text('XUSHUAXINHF'),
            okText: getIn18Text('setting_system_switch_web'),
            onOk: () => {
                mailReset();
                modal.destroy();
            },
        });
    };
    const mailSendRevoke = (params) => {
        const { resModel } = params;
        const { id, cid, createTime, entry, aliasSender, _account, sentTInfo, scheduleDate } = resModel;
        const { tid = '', title } = entry;
        const sendRevokeRes = dataStoreApi.getSync('sendRevoke');
        const sendRevokeOpen = !!sendRevokeRes.suc && sendRevokeRes.data === 'ON';
        const revokeable = sendRevokeOpen && !scheduleDate;
        if (!revokeable)
            return;
        const curSendingMail = {
            cid,
            id,
            tid,
            createTime,
            title,
            sentTInfo,
            source: 'tab',
            optSenderStr: (aliasSender === null || aliasSender === void 0 ? void 0 : aliasSender.id) || _account,
        };
        if (!inElectron) {
            dispatch(mailActions.doAddSendingMails(curSendingMail));
        }
        else {
            if (locationHelper.testPathMatch('/writeMail')) {
                eventApi.sendSysEvent({
                    eventName: 'sendingMail',
                    eventData: Object.assign(Object.assign({}, curSendingMail), { source: 'writeMail' }),
                });
                return;
            }
            dispatch(mailActions.doAddSendingMails(curSendingMail));
        }
    };
    const sendSuc = useCreateCallbackForEvent(async (params) => {
        var _a;
        const { curSendId, recoverCid, resModel, reqData } = params;
        const { errMsg, cid, entry, _account, composeId = '' } = resModel;
        const { tid = '', id: orginMid } = entry;
        const isSendCurrentMail = curSendId === currentMailIdRef.current;
        const isVariableMail = composeId.length > 0;
        if (process.env.BUILD_ISEDM) {
            try {
                const { writeType } = currentMail;
                if ((writeType === null || writeType === void 0 ? void 0 : writeType.includes('reply')) && !(writeType === null || writeType === void 0 ? void 0 : writeType.includes('replreplyAllAsNewy'))) {
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            ids: [orginMid],
                            accounts: [_account],
                            mark: true,
                            showMessage: false,
                        },
                        eventStrData: 'markProcessFollow',
                        _account,
                    });
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        performanceApi.timeEnd({ statKey: 'mail_send_over', statSubKey: `${cid}` });
        loggerApi.track('send_suc_enter', {
            curSendId,
            cid,
            composeId: resModel._id || '',
            hasErrMsg: !!errMsg,
        });
        if (errMsg) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
            loggerApi.track('send_suc_with_err_msg', { curSendId, errMsg });
            setErrorMsg(errMsg);
            setVisibleErrorContect(true);
            return;
        }
        dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: 'success' }));
        loggerApi.track('send_suc_status_set', { curSendId });
        joinWebmailActivity(tid);
        cid && dispatch(appActions.doDelAttachment({ cid: [cid] }));
        mailDraftApi.deleteDraftMailByCid(curSendId);
        !isVariableMail && curSendId && sucDealReducer(curSendId, isSendCurrentMail);
        cid && clearMidFile(cid);
        dataStoreApi.put('lxWriteRemind', (!!reqData.senderReceivers).toString(), { noneUserRelated: true });
        const accounts = await accountApi.getMainAndSubAccounts();
        const mainAccount = (_a = accounts[0]) === null || _a === void 0 ? void 0 : _a.mainAccount;
        if (_account === mainAccount) {
            renewalCloudAtt(entry.attachment || []);
            recoverCid && delLocalDraft(recoverCid);
            if (!inElectron) {
                if (locationHelper.testPathMatch('/readMailComb')) {
                    return;
                }
                if (isSendCurrentMail) {
                    if (onSendSuccess && composeId.length > 0) {
                        onSendSuccess && onSendSuccess(resModel.composeId, curSendId);
                    }
                    else {
                        navigateWithSearchQuery('/#mailbox');
                        dispatch(mailTabActions.doChangeCurrentTab('-1'));
                    }
                }
                mailSendRevoke({ resModel });
            }
            else {
                if (locationHelper.testPathMatch('/writeMail')) {
                    mailSendRevoke({ resModel });
                    return;
                }
                if (isSendCurrentMail) {
                    if (onSendSuccess && composeId.length > 0) {
                        onSendSuccess && onSendSuccess(resModel.composeId, curSendId);
                    }
                    else {
                        navigateWithSearchQuery('/#mailbox');
                        dispatch(mailTabActions.doChangeCurrentTab('-1'));
                    }
                }
                mailSendRevoke({ resModel });
            }
        }
        else {
            mailSendRevoke({ resModel });
        }
    });
    const subAccountUpdateConf = (_account) => {
        var _a;
        if (_account && _account !== ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id)) {
            mailConfApi.loadConfFromServer(_account);
        }
    };
    const sendFail = useCreateCallbackForEvent(async (params) => {
        var _a;
        const { err, curSendId, reqData } = params;
        const isSendCurrentMail = curSendId === currentMailIdRef.current;
        dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
        console.log(getIn18Text('FASONGSHIBAI'), err);
        const errMessage = typeof err === 'string' ? err : err.message || err.code || err.title;
        if (typeof err === 'string' && ['free_version_total_size_overflow', 'free_version_attachment_size_overflow'].includes(err)) {
            paidGuideModal.show({ errType: '41', origin: '写信' });
        }
        else if (errMessage === 'FA_MTA_RETRY' || errMessage === 'FA_MTA_ICSRETRY') {
            try {
                loggerApi.track('useReupload_modal');
                subAccountUpdateConf(reqData._account || '');
            }
            catch (error) {
                console.log('loggerApi_useReupload_modal', error);
            }
            const modal = SiriusModal.error({
                title: getIn18Text('FUJIANCHONGCHUAN'),
                content: getIn18Text('DIANJIQUEREN'),
                okText: getIn18Text('QUERENSHANGCHUAN'),
                onOk: () => {
                    if (locationHelper.testPathMatch('/writeMail') || curSendId === currentTabIdRef.current) {
                        reUploadAtts(reqData._account);
                        modal.destroy();
                    }
                    else {
                        if (mails.find(mail => mail.cid === curSendId) && tabList.find(tab => tab.id === curSendId)) {
                            dispatch(mailTabActions.doChangeCurrentTab(curSendId));
                            currentMailIdRef.current !== curSendId && dispatch(mailActions.doChangeCurrentMail(curSendId));
                            setTimeout(() => {
                                if (currentTabIdRef.current === curSendId && currentMailIdRef.current === curSendId) {
                                    reUploadAtts(reqData._account);
                                }
                                else {
                                    message.error(getIn18Text('ZHONGCHUANSHIB'));
                                }
                                modal.destroy();
                            }, 200);
                        }
                    }
                },
                hideCancel: true,
                onCancel: () => {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
                },
            });
        }
        else if (errMessage === 'FA_MTA_RETRY_SILENT') {
            if (inElectron) {
                try {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: 'reGenerating' }));
                    const reUploadRes = await reUploadHandler(reqData._account);
                    dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
                    if (reUploadRes && reUploadRes.every(i => i.status === 'fulfilled')) {
                        message.info({ content: getIn18Text('SHANGCHUANWANCQZXDJF1'), className: style.succMsg });
                    }
                    else {
                        message.error(getIn18Text('SHANGCHUANSHIBAI'));
                    }
                    subAccountUpdateConf(reqData._account || '');
                }
                catch (error) {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
                    message.error(getIn18Text('SHANGCHUANSHIBAI'));
                }
            }
            else {
                try {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: 'reGenerating' }));
                    const reUploadRes = await reUploadHandlerWeb(reqData._account, true);
                    dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
                    message.info({ content: getIn18Text('SHANGCHUANWANCQZXDJF1'), className: style.succMsg });
                    subAccountUpdateConf(reqData._account || '');
                }
                catch (error) {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
                    message.error(getIn18Text('SHANGCHUANSHIBAI'));
                }
            }
        }
        else if (errMessage == 'MAIL_STATUS_ERROR') {
            if (isSendCurrentMail) {
                mailStatusError();
            }
            else {
                SiriusMessage.error({ content: getIn18Text('YOUJIANFUJZTYC') });
            }
        }
        else if (errMessage == 'FA_MTA_REJECTED552') {
            setTimeout(() => {
                SiriusMessage.error({ content: getIn18Text('ZHANGHAORONGLCGXZ') });
            }, 500);
        }
        else if (errMessage === 'ERR.SUBACCOUNT.EXPIRED') {
            SiriusMessage.error({ content: getIn18Text('ZIZHANGHAOGQ') });
        }
        else if ((err === null || err === void 0 ? void 0 : err.simpleIntro) === 'needRiskAuth') {
            const { url } = err;
            url && setAuthData({ show: true, authPath: url, curSendId });
        }
        else {
            if (!(((_a = err) === null || _a === void 0 ? void 0 : _a.remindWay) === 'event' && systemApi.isMainPage())) {
                SiriusMessage.error({ content: getIn18Text('FASONGSHIBAI') });
            }
            dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
        }
    });
    const isReadOnly = (obj, prop) => {
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return descriptor ? !descriptor.writable : false;
    };
    const generateData = useCreateCallbackForEvent(async (params) => {
        var _a, _b, _c, _d;
        const { receiver, icsReupload, curSendId: curId, useVariable } = params || {};
        const curSendId = curId || currentMailId;
        const curMail = curSendId === currentMailId ? currentMail : mails.find(mail => mail.cid === curSendId);
        if (!curMail)
            return;
        const isSendCurrentMail = curSendId === currentMailIdRef.current;
        const { status, senderReceivers, optSenderMainEmail, optSender } = curMail;
        const { conferenceShow, praiseMailShow, taskMailShow } = status || {};
        dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: 'delivering' }));
        let data = util.cloneDeep(curMail);
        if (!scheduledSent) {
            dispatch(mailActions.doChangeMailSchedule({ id: curId, scheduleDate: undefined }));
            dispatch(mailActions.doChangeMailScheduleTimeZone({ id: curId, scheduleTimeZone: undefined }));
            data.scheduleDate = '';
        }
        else {
            if (data.scheduleDate) {
                data.scheduleDate = (_a = systemApi.timeZoneTrans(data.scheduleDate, data.scheduleDateTimeZone || 0, 8)) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD HH:mm:ss');
            }
        }
        if (optSender) {
            data.aliasSender = { id: optSender.id, nickName: optSender.senderName, mailEmail: optSender.mailEmail || '' };
        }
        if (receiver) {
            data = Object.assign(Object.assign({}, curMail), { receiver });
        }
        if (conferenceShow && (data.initSenderStr === optSenderMainEmail || icsReupload) && !((_b = curMail === null || curMail === void 0 ? void 0 : curMail.conference) === null || _b === void 0 ? void 0 : _b.uploadSuc)) {
            const hasError = await calendarSubmit({ currentMail: curMail, setVisibleConf, isSendCurrentMail });
            if (hasError) {
                dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
                return;
            }
            else {
                dispatch(mailActions.doConferenceUploadChange({ cid: curSendId, uploadSuc: true }));
            }
        }
        if (praiseMailShow) {
            data = dealPraiseMail(data);
        }
        if (taskMailShow) {
            data = await dealTaskMail(data);
        }
        data.senderReceivers = senderReceivers;
        const accounts = await accountApi.getMainAndSubAccounts();
        const mainAccount = (_c = accounts[0]) === null || _c === void 0 ? void 0 : _c.mainAccount;
        if (mainAccount !== optSenderMainEmail) {
            data._account = optSenderMainEmail;
            data.sender = mailApi.buildRawContactItem();
        }
        else {
            data._account = mainAccount;
        }
        const currentAttachment = attachments.filter(i => i.mailId === curSendId);
        const linkAttached = currentAttachment.some(attachment => { var _a; return !!((_a = attachment === null || attachment === void 0 ? void 0 : attachment.flag) === null || _a === void 0 ? void 0 : _a.usingCloud) || !!(attachment === null || attachment === void 0 ? void 0 : attachment.cloudAttachment) || (attachment === null || attachment === void 0 ? void 0 : attachment.type) === 'netfolder'; });
        if (linkAttached) {
            data.entry.linkAttached = linkAttached;
        }
        if (typeof useVariable === 'boolean') {
            data.includeVariable = useVariable;
        }
        else if ((_d = data === null || data === void 0 ? void 0 : data.status) === null || _d === void 0 ? void 0 : _d.useVariable) {
            data.includeVariable = true;
        }
        if (data.isDyncGroupSend || data.includeVariable) {
            try {
                const resContent = edmOperateVarBeforeSend(data.entry.content.content);
                data.entry = Object.assign(Object.assign({}, data.entry), { content: Object.assign(Object.assign({}, data.entry.content), { content: resContent }) });
                data.entry.content.content = resContent;
            }
            catch (error) {
                console.error('赋值失败', error);
                return;
            }
        }
        if (isEdm()) {
            data.entry.title = edmOperateVarSubject(data.entry.title, variableList === null || variableList === void 0 ? void 0 : variableList.showToCode);
        }
        return data;
    });
    const saveSend = useCreateCallbackForEvent(async (params) => {
        const curSendId = (params === null || params === void 0 ? void 0 : params.curSendId) || currentMailId;
        const curMail = curSendId === currentMailId ? currentMail : mails.find(mail => mail.cid === curSendId);
        const { recoverCid, waitSave } = curMail;
        const storeEditStatus = getTargetEditStatus(curSendId);
        const isAutoSendPath = !!(params === null || params === void 0 ? void 0 : params.curSendId);
        if (storeEditStatus === 'success' || (isAutoSendPath && storeEditStatus === 'delivering')) {
            loggerApi.track('save_send_blocked_by_status', {
                curSendId,
                storeEditStatus,
                isAutoSendPath,
                trigger: isAutoSendPath ? 'autoSend' : 'manual',
            });
            return;
        }
        if (isAutoSendPath) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: 'delivering' }));
        }
        loggerApi.track('save_send_start', {
            curSendId,
            storeEditStatus,
            trigger: isAutoSendPath ? 'autoSend' : 'manual',
        });
        dispatch(mailActions.doRemWaittingMailId(curSendId));
        if (curSendId && getWaittingSaveMails().get(curSendId) && curMail) {
            await mailApi.doSaveTemp({ content: curMail, saveDraft: true, auto: true });
        }
        try {
            const data = await generateData(params);
            try {
                performanceApi.time({ statKey: 'mail_send_over', statSubKey: `${data.cid}` });
                mailApi
                    .doSendMail(data)
                    .then(async (resModel) => {
                    if (getTargetEditStatus(curSendId) === 'success')
                        return;
                    sendSuc({ resModel, reqData: data, curSendId: curSendId, recoverCid });
                })
                    .catch(async (err) => {
                    if (getTargetEditStatus(curSendId) === 'success')
                        return;
                    sendFail({ err, curSendId: curSendId, reqData: data });
                });
            }
            catch (e) {
                console.log(getIn18Text('FASONGSHIBAI'), e);
                SiriusMessage.error({ content: getIn18Text('FASONGSHIBAI') });
                dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
            }
        }
        catch (err) {
            console.error('发送失败', err);
            dispatch(mailActions.doModifyMailEditStatus({ cid: curSendId, status: '' }));
        }
    });
    useEffect(() => {
        setScheduledSent && setScheduledSent(!!scheduleDate);
    }, [scheduleDate]);
    useEffect(() => {
        setSaveTime('');
    }, [currentMailId]);
    useEffect(() => {
        if (editorInstance) {
            if (puretext) {
                const toolbarList = editorInstance.settings.toolbar_mode === 'scrolling' ? ['lxuploadattachment'] : 'lxuploadattachment';
                editorInstance.fire('changeToolbar', { toolbarList });
                return;
            }
            editorInstance.fire('changeToolbar');
        }
    }, [puretext]);
    const isSubAccount = useDebounceForEvent(async () => {
        try {
            const isSub = await accountApi.isSubAccount(optSenderMainEmail);
            setIsSub(isSub || false);
        }
        catch (error) {
            console.log('isSubAccount error', error);
            setIsSub(false);
        }
    }, 200);
    useEffect(() => {
        isSubAccount();
    }, [optSenderMainEmail]);
    const puretextChange = () => {
        if (editorInstance) {
            if (puretext) {
                dispatch(doSetPuretext(false));
                return;
            }
            const hasVar = textHaveVar(currentMailTitle);
            const contentHasVar = mailContentHasVar();
            if (hasVar.customVar || hasVar.systemVar || contentHasVar) {
                message.warning({
                    content: '纯文本邮件暂不支持插入变量',
                });
                return;
            }
            setPuretextVisible(true);
        }
    };
    const confirmPuretext = () => {
        var _a, _b;
        if (!editorInstance)
            return;
        const content = editorInstance.getContent({ format: 'text' });
        dispatch(doChangeMailContent(content));
        const mail = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(currentMail))), { _account: senderEmail });
        if ((_b = (_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content) {
            mail.entry.content.content = content;
        }
        mailApi.doSaveMailLocal(mail);
        dispatch(doSetPuretext(!puretext));
        setPuretextVisible(false);
    };
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${style.layer}`, hidden: !tooltipVisible }),
        React.createElement("div", { className: style.sendFooter, id: "sendfooter", ref: sendfooterRef },
            setEncrypt && React.createElement(EncryptMail, null),
            scheduledSent && React.createElement(ScheduledSent, null),
            React.createElement("div", { className: `ant-allow-dark ${style.footerTop}` },
                React.createElement(SenderSelectComp, { setSender: setSender }),
                React.createElement("div", null,
                    !currentMail.isDyncGroupSend && React.createElement(React.Fragment, null, isCorpMail || comIsShowByAuth(ProductAuthorityFeature.MAIL_TRACE_WRITE_EMAIL_SHOW, React.createElement(ReadRemindComp, null))),
                    !isEdm() && productVersionId === 'free' && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: style.emergency },
                            React.createElement(Checkbox, { checked: false, onClick: () => paidGuideShow('7') }, getIn18Text('YIDUTIXING')),
                            React.createElement(Tooltip, { arrowPointAtCenter: true, getPopupContainer: () => document.getElementById('sendfooter') || document.body, placement: "topLeft", title: getIn18Text('GOUXUANCIGONGNENG11') },
                                React.createElement(IconWarn, null))),
                        React.createElement("div", { className: style.emergency },
                            React.createElement(Checkbox, { checked: false, onClick: () => paidGuideShow('8') }, getIn18Text('ZHUIZONGYOUJIANYUEDZT'))))),
                    React.createElement("div", { className: style.emergency },
                        React.createElement(Checkbox, { checked: requestReadReceipt, onClick: requestReadReceiptChange }, getIn18Text('YIDUHUIZHI'))),
                    React.createElement("div", { className: `${style.schedule}` },
                        React.createElement(Checkbox, { checked: puretext, onClick: puretextChange }, getIn18Text('CHUNWENBEN'))),
                    React.createElement("div", { className: `${style.schedule}`, onClick: scheduledSentChangeDisabled },
                        React.createElement(Checkbox, { checked: scheduledSent, disabled: praiseMailShow || taskMailShow || setEncrypt, onClick: scheduledSentChange }, getIn18Text('DINGSHIFASONG'))),
                    React.createElement("div", { className: style.emergency },
                        React.createElement(Checkbox, { checked: !!(typeof priority === 'number' && priority < 2), onClick: emergencyChange }, getIn18Text('JINJI'))),
                    encryptMailCkShow && (React.createElement("div", { className: `${style.encryptMailCk}` },
                        React.createElement(Checkbox, { checked: setEncrypt, onClick: encryptMailChange, disabled: encryptMailDisabled }, getIn18Text('YOUJIANJIAM')))))),
            React.createElement("div", { className: style.footerBottom },
                React.createElement("div", { style: { marginRight: '8px' }, ref: sendRef, "data-test-id": "send-mail" },
                    React.createElement(SendValidateComp, { sendLoading: sendLoading, tooltipVisible: tooltipVisible, scheduledSent: scheduledSent, setTooltipVisible: setTooltipVisible, saveSend: saveSend, editorInstance: editorInstance })),
                React.createElement(SaveDraft, { saveTime: saveTime, tooltipVisible: tooltipVisible, execAutoSaveDraft: execAutoSaveDraft, forceSave: forceSave, updateSaveTime: updateSaveTime, sendLoading: sendLoading }),
                React.createElement(SaveAsTemplateComp, { isContentChanged: !!isContentChanged }),
                innerCloseTab && currentMailId && !inElectron && React.createElement(CloseButton, { innerCloseTab: innerCloseTab, id: currentMailId }),
                React.createElement(MailSize, null),
                subAccountExpired && React.createElement("span", { className: style.subAccountExpiredText }, getIn18Text('DANGQIANYOUJIANYISX，QZYBFYJNRHGBXXYZS')))),
        visibleErrorContect && (React.createElement(SendErrorContect, { visible: visibleErrorContect, setVisible: setVisibleErrorContect, receiver: receiverMemo, errorMsg: errorMsg, confirm: errorContectResend })),
        React.createElement(Dialog, { isModalVisible: puretextVisible, okText: getIn18Text('QUEDING'), title: getIn18Text('YOUJIANZHUANWCWBJHYS10'), isCancel: true, onOk: confirmPuretext, onCancel: () => {
                setPuretextVisible(false);
            } }),
        (authData === null || authData === void 0 ? void 0 : authData.show) && React.createElement(Auth, { authData: authData, setAuthData: setAuthData })));
});
export default SendMail;
